import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

export function Dashboard() {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      navigate('/sign-in');
      return;
    }
    if (isLoaded && isSignedIn) {
      // Redirect to campaigns page (which shows landing or campaign list)
      navigate('/campaigns', { replace: true });
    }
  }, [isLoaded, isSignedIn, navigate]);

  return null;
}
